<div class="module-customizer-wrapper">
<div class="dashboard-modules-dimensions" >
    <div class="module-customizer-title">Customize Dashboard</div>
    <div class="module-dynamic-buttons">
        <button class="btn-medium-primary" (click)="save()">Save</button>
        <button class="btn-medium-secondary" (click)="close()">Cancel</button>
    </div>
    <div class="clear" style="height: 7px;"></div>


    @if (modulesToBuild && modulesToBuild.length > 0 && !isUiTest) {
        <div class="module-dynamic-builder" cdkDropList cdkDropListOrientation="mixed" (cdkDropListDropped)="drop($event)">
            @for (module of modulesToBuild; track module.id) {
                <div cdkDrag class="dynamic-module" [class.module-single-view]="module.singleWidth" [class.module-double-view]="!module.singleWidth" [cdkDragDisabled]="!module.enabled">
                    <p-card>
                        <div class="module-customize-header-row" style="display: flex;flex-direction: row;justify-content: space-between;padding: 15px 15px 10px 15px;cursor: default;">
                            <div style="white-space: nowrap" class="module-title">
                                {{module.moduleTitle}}
                                @if (module.info) {
                                    <span tooltip [tooltipTitle]="module.info" [tooltipPosition]="'bottom'"  style="padding-left: 5px;">
                                        <img src="../../assets/images/info-outline.png" width="16" height="16" style="vertical-align: middle;">
                                    </span>
                                }
                            </div>
                            <div style="text-align: right;display: flex; flex-direction: row;padding-left:5px;">
                                @if (module.singleWidth && module.allowDoubleWidth) {
                                    <div style="padding-right:10px;">
                                        <img class="svg-expand-panel" src="../../assets/images/expand-panel.svg" width="20" height="16" (click)="toggleModuleWidth(module, false)">
                                    </div>
                                }
                                @if (!module.singleWidth && module.allowDoubleWidth) {
                                    <div style="padding-right:10px;">
                                        <img class="svg-collapse-panel" src="../../assets/images/collapse-panel.svg" width="20" height="16" (click)="toggleModuleWidth(module, true)">
                                    </div>
                                }

                                <as-switch size="compact"
                                           [disabled]="disableSwitch && module.enabled"
                                        [checked]="module.enabled"
                                        (change)="toggleEnableModule(module)">
                                </as-switch>
                            </div>
                        </div>
                        <div class="module-skeleton-wrap" [class.customize-module-disabled]="!module.enabled">
                            <ng-container [ngComponentOutlet]="module.type" [ngComponentOutletInputs]="{singleWidth: module.singleWidth, customizableMode: true}"></ng-container>
                        </div>
                    </p-card>
                </div>

            }
        </div>
    }
</div>
</div>

